import { SegmentEntity, SegmentsOrder } from "../../../entities";
export const SegmentRegisterRequestSchema = SegmentEntity.schema.pick({
    name: true,
});
export const SegmentInitRegisterRequestSchema = SegmentEntity.schema.pick({
    id: true,
    name: true,
    version: true,
});
export const SegmentUpdateRequestSchema = SegmentEntity.schema.pick({
    name: true,
    version: true,
});
export const SegmentOrderUpdateRequestSchema = SegmentsOrder.schema.partial({
    version: true,
});
//# sourceMappingURL=segment-request.js.map